import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

import { PrismDialogComponent } from '@shure/prism-angular-components';

@Component({
	selector: 'sh-cookie-dialog',
	templateUrl: './cookie-dialog.component.html',
	styleUrls: ['./cookie-dialog.component.scss'],
	standalone: true,
	imports: [CommonModule, PrismDialogComponent, TranslocoModule]
})
export class CookieDialogComponent {}
